import Confirm from './Confirm.vue'
import store from '../../../store'

function Install(Vue, options) {
    const property = (options && options.property) || '$confirm'
    function createDialogCmp(options, componentProps) {
        return new Promise(resolve => {
            const cmp = new Vue(Object.assign({}, Confirm, {
                store,
                propsData: Object.assign(
                    {},
                    Vue.prototype.$confirm.options,
                    options,
                    { componentProps: componentProps }
                ),
                destroyed: (c) => {
                    try {
                        if (options.appendTo) {
                            document.querySelector(options.appendTo).removeChild(cmp.$el)
                        } else {
                            document.body.removeChild(cmp.$el)                        
                        }
                    } catch (e) {

                     }
                    resolve(cmp.value)
                }
            }))
            if (options.appendTo) {
                document.querySelector(options.appendTo).appendChild(cmp.$mount().$el)
            } else {
                document.body.appendChild(cmp.$mount().$el)
            }
        })
    }

    function show(message, options = {}, componentProps) {
        options.message = message
        return createDialogCmp(options, componentProps)
    }

    Vue.prototype[property] = show
    Vue.prototype[property].options = options || {}
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(Install)
}

export default Install